import { Field, useFormState } from "react-final-form";
import { useIntl } from "react-intl";
import * as Validations from "../../../common/form/validator";
import {
  DropdownInput,
  SwitchInput,
  Tags,
  TextInput,
} from "../../../common/fields";
import { GlobalConstants } from "../../../../constants";

const CustomFieldForm = ({ record }) => {
  const formState = useFormState();
  const intl = useIntl();
  return (
    <div className="grid">
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="name"
          component={TextInput}
          type="text"
          label={intl.formatMessage({
            id: "name",
          })}
          placeholder={intl.formatMessage({
            id: "name",
          })}
          required
          validate={Validations.composeValidators(
            Validations.required,
            Validations.validateAplahbetsAndSpace
          )}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="label"
          component={TextInput}
          type="text"
          label={intl.formatMessage({
            id: "label",
          })}
          placeholder={intl.formatMessage({
            id: "label",
          })}
          required
          validate={Validations.composeValidators(
            Validations.required,
            Validations.validateAplahbetsAndSpace
          )}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="type"
          options={GlobalConstants.FIELD_TYPES}
          component={DropdownInput}
          label={intl.formatMessage({
            id: "type",
          })}
          placeholder={intl.formatMessage({
            id: "type",
          })}
          readOnly={record && record.id}
          required
          validate={Validations.composeValidators(Validations.required)}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="isRequired"
          component={SwitchInput}
          type="checkbox"
          label={intl.formatMessage({
            id: "required",
          })}
          placeholder={intl.formatMessage({
            id: "required",
          })}
        />
      </div>
      {(formState.values.type === 3 && (
        <div className="col-12 md:col-6 lg:col-4">
          <Field
            name="options"
            component={Tags}
            label={intl.formatMessage({
              id: "options",
            })}
            placeholder={intl.formatMessage({
              id: "options",
            })}
            removeOptionsDisabled={(record && record.id && true) || false}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
        </div>
      )) ||
        null}
      {(formState.values.type === 4 && (
        <>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="yes_label"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "yes_label",
              })}
              placeholder={intl.formatMessage({
                id: "yes_label",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="no_label"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "no_label",
              })}
              placeholder={intl.formatMessage({
                id: "no_label",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </>
      )) ||
        null}
    </div>
  );
};

export default CustomFieldForm;
